import { Handle, Position } from 'reactflow';
import { Zap, AlertTriangle } from 'lucide-react';
import { resumoDoGatilho, pendenciaDoGatilho } from '@shared/flow-triggers';

/**
 * O cartão "Começa quando", no topo do fluxo.
 *
 * Até a 1.64 o gatilho só existia no diálogo de criação da lista de fluxos:
 * dentro do editor não havia como ver nem trocar o que dispara o fluxo — para
 * mudar de palavra-chave era preciso apagar e recriar. E quem abria um fluxo
 * existente não tinha como saber por que ele rodava.
 *
 * É um nó sintético: existe só no desenho, nunca entra em `nodes` nem é salvo.
 * O gatilho mora em `flows.triggerType`/`triggerValue`, e o cartão é a janela
 * para ele. Por isso não tem entrada, não se arrasta e não se apaga.
 */
export default function GatilhoNode({ data }: any) {
  const { triggerType, triggerValue, nomeDaEtiqueta, aoAlterar } = data as {
    triggerType?: string | null;
    triggerValue?: string | null;
    nomeDaEtiqueta?: string | null;
    aoAlterar?: () => void;
  };
  const pendencia = pendenciaDoGatilho(triggerType, triggerValue);

  return (
    <>
      <div
        className={`w-[300px] rounded-xl bg-slate-900 text-white shadow-md border ${
          pendencia ? 'border-amber-400/60' : 'border-slate-900'
        }`}
      >
        <div className="flex items-center gap-2.5 p-3">
          <div className="w-7 h-7 rounded-lg bg-white/10 flex items-center justify-center shrink-0">
            <Zap className="w-3.5 h-3.5 text-amber-300" strokeWidth={2} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-[9px] font-semibold uppercase tracking-wider text-white/50">
              Começa quando
            </div>
            <div className="text-xs font-medium truncate">
              {resumoDoGatilho(triggerType, triggerValue, nomeDaEtiqueta)}
            </div>
          </div>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              aoAlterar?.();
            }}
            className="shrink-0 rounded-md px-2 py-1 text-[11px] text-white/70 hover:text-white hover:bg-white/10 transition-colors"
          >
            Alterar
          </button>
        </div>

        {pendencia && (
          <div className="flex items-center gap-1.5 border-t border-white/10 px-3 py-1.5 text-[10px] font-medium text-amber-300">
            <AlertTriangle className="w-3 h-3 shrink-0" strokeWidth={2} />
            {pendencia.curta}
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id="gatilho"
        isConnectable={false}
        className="!w-2.5 !h-2.5 !bg-slate-400 !border-slate-500"
      />
    </>
  );
}
